module.exports = __webpack_public_path__ + "img/1530540555.b671798c.jpg";